export default __webpack_public_path__ + "static/media/hht2_Intonation_17.6d4d854e.png";